import { apiClient } from "../config";

async function deleteProtocol(id: string) {
  const url = `/admin/protocols/${id}`;
  const res = await apiClient.delete(url);
  return res.data;
}

export default deleteProtocol;
